import React from "react";
import styled from "styled-components";
import { Avatar } from "@material-ui/core";
import { Accessibility } from "./accessibility";
import { MenuToggle } from "./menuToggle";
import { SidebarDataForMenu } from "./SidebarDataForMenu";
import Link from "./Link";
import { useStateValue } from "../../StateProvider";

const NavLinksContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 100000;
`;

const LinksWrapper = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  height: 100%;
  list-style: none;
  background-color: rgb(240, 240, 240);
  width: 100%;
  flex-direction: column;
  position: fixed;
  top: 65px;
  left: 0;
  z-index: 100000;

`;

const LinkItem = styled.li`
  width: 100%;

  padding: 0 1.1em;
  padding-top: 12px;
  color: #0d7a2b;
  font-weight: 500;
  font-size: 24px;
  display: flex;
  z-index: 100000;
  transition: all 220ms ease-in-out;

  margin-bottom: 10px;

  &:hover {
    color: #1db954;
    transform: scale(1.05);
  }
`;

// const Link = styled.a`
//   text-decoration: none;
//   color: inherit;
//   font-size: inherit;
// `;

const Marginer = styled.div`
  height: 2em;
`;

const MobileUserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
`;

const StyledAvatar = styled(Avatar)`
  width: 48px !important;
  height: 48px !important;
  background: linear-gradient(135deg, #6366f1, #22d3ee);
  font-size: 18px !important;
  font-weight: bold !important;
`;

const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

const UserName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

const SubscriptionBadge = styled.span`
  font-size: 11px;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  width: fit-content;

  ${props => props.tier === 'premium' ? `
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    color: #333;
    box-shadow: 0 2px 6px rgba(255, 215, 0, 0.3);
  ` : `
    background: rgba(150, 150, 150, 0.2);
    color: #666;
    border: 1px solid rgba(150, 150, 150, 0.3);
  `}
`;

export function MobileNavLinks(props) {

  const [{isOpen, user, userTier, testmode}, dispatch] = useStateValue();

  const handleAddSongClick = () => {
    // Close mobile menu
    dispatch({
      type: "SET_STATEMOBILEMENU",
      isOpen: false,
    });
    // Navigate to Add Song screen
    dispatch({
      type: "SET_MENUSTATE",
      menustate: "addownsong",
    });
  };

  return (
    <NavLinksContainer>
      <MenuToggle isOpen={isOpen} toggle={() =>


        {

          dispatch({
            type: "SET_STATEMOBILEMENU",
            isOpen: !isOpen,
          });

        }


        } />

      {/* // WIRD GERENDET WHEN isOpen */}
      {isOpen && (
        <LinksWrapper>

          {/* User Info Section at the top of mobile menu */}
          {user && (
            <MobileUserSection>
              <StyledAvatar
                alt={user?.display_name}
                src={user?.images?.[0]?.url}
              >
                {!user?.images?.[0]?.url && user?.display_name?.[0]?.toUpperCase()}
              </StyledAvatar>
              <UserInfoWrapper>
                <UserName>{user?.display_name}</UserName>
                <SubscriptionBadge tier={userTier}>
                  {userTier === 'premium' ? '👑 Premium' : 'Free'}
                </SubscriptionBadge>
              </UserInfoWrapper>
            </MobileUserSection>
          )}

          {SidebarDataForMenu.map((item, index) => {


          return <LinkItem key={index}><Link option={item.title} path={item.path} > </Link></LinkItem>


          })}

          {/* Test mode: Add Song menu item */}
          {testmode && (
            <LinkItem onClick={handleAddSongClick} style={{ cursor: 'pointer' }}>
              <div>
                <button type="button"><h4>Add Song</h4></button>
              </div>
            </LinkItem>
          )}

          {/* <LinkItem>
            <Link href="#">About us</Link>
          </LinkItem>
          <LinkItem>
            <Link href="#">How it works</Link>
          </LinkItem>
          <LinkItem>
            <Link href="#">Explore</Link>
          </LinkItem>
          <LinkItem>
            <Link href="#">Impact</Link>
          </LinkItem> */}
          <Marginer />
          <Accessibility />
        </LinksWrapper>
      )}
    </NavLinksContainer>
  );
}
